// extracted by css-extract-rspack-plugin
export default {"infoIcon":"infoIcon-C6oxA7","tooltip":"tooltip-cs5UCK"};